<div class="auth-wrapper">

  <mat-card class="auth-card">
    <mat-card-content>

      <h2 class="title">Forgot Password?</h2>
      <p class="subtitle">Enter your email and we’ll send you reset instructions.</p>

      <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Email Address</mat-label>
          <input matInput formControlName="email" placeholder="name@company.com" />
          <mat-error *ngIf="form.get('email')?.hasError('required')">
            Email is required
          </mat-error>
          <mat-error *ngIf="form.get('email')?.hasError('email')">
            Enter a valid email address
          </mat-error>
        </mat-form-field>

        <button mat-flat-button color="primary" class="w-100" [disabled]="form.invalid || loading">
          {{ loading ? 'Sending...' : 'Send Reset Link' }}
        </button>

      </form>

      <div class="back-link">
        <a routerLink="/customers/login">← Back to Sign In</a>
      </div>

    </mat-card-content>
  </mat-card>

</div>
